/**
 * This composable is used to create and track dismissible cookies.
 */
import { ONE_WEEK_IN_SECONDS } from '#shared/constants/durations'
import type { COOKIES } from '#shared/constants/cookies'

type CookieConfig = {
  id: COOKIES
  version?: number
  expiresInSeconds?: number
  page?: string
}

export default function useDismissCookie({ id, version, expiresInSeconds = ONE_WEEK_IN_SECONDS, page }: CookieConfig) {
  const cookie = useCookie([id, page, version].filter(Boolean).join('-'), {
    /* c8 ignore next */
    default: () => '',
    maxAge: expiresInSeconds,
  })

  function dismissCookie() {
    cookie.value = 'dismissed'
  }

  return {
    isDismissed: computed(() => cookie.value === 'dismissed'),
    dismissCookie,
  }
}
